import { ViolationClassificationDTO } from "src/models/violation-classification/violation-classification-dto";
import { ViolationClassificationSTO } from "src/models/violation-classification/violation-classification-sto";
import { BaseApiService } from "../base";

export class ViolationClassificationApiService extends BaseApiService<
  ViolationClassificationDTO,
  ViolationClassificationSTO
> {
  constructor() {
    super({
      servicePath: "/ViolationClassification",
      loadItemsPath: "/GetViolationClassifications",
      saveItemsPath: "/SaveViolationClassifications",
    });
  }
}
